import { apiGet, apiPost } from '../../MainModule/common/apiTools';
import { getServiceBaseURL } from '../../MainModule/common/getServiceBaseURL';
import { APIServiceEnum } from '../../MainModule/enums/APIServiceEnum';
import { IErvkObjectsOfControl } from '../interfaces/IErvkObjectsOfControl';

export async function fetchErvkObjectsOfControl(
  knoOrganizationDictVersionId: string,
  supervisionTypeDictVersionId: string,
  cosIdFilter: string | undefined,
  textFilter: string | undefined,
  riskCategoryIds: string[] | undefined,
  dangerClassIds: string[] | undefined,
  conditionUuid: string | undefined,
  isPlanned: boolean | undefined,
): Promise<IErvkObjectsOfControl[]> {
  const queryParams = new URLSearchParams();

  queryParams.append('organizationId', knoOrganizationDictVersionId);
  queryParams.append('supervisionId', supervisionTypeDictVersionId);
  if (textFilter) {
    queryParams.append('text', textFilter);
  }
  if (cosIdFilter) {
    queryParams.append('cosId', cosIdFilter);
  }
  if (riskCategoryIds) {
    riskCategoryIds.forEach(uuid => queryParams.append('riskCategoryIds', uuid));
  }
  if (dangerClassIds) {
    dangerClassIds.forEach(uuid => queryParams.append('dangerClassIds', uuid));
  }
  conditionUuid && queryParams.append('conditionUuid', conditionUuid);
  typeof isPlanned === 'boolean' && queryParams.append('isPlanned', String(isPlanned));

  return apiGet<IErvkObjectsOfControl[]>(
    `${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/dictionaries/constraint/get-control-objects?${queryParams}`,
  );
}

export async function findErvkObjectsOfControl(query: string): Promise<IErvkObjectsOfControl[]> {
  return apiGet(
    `${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/dictionaries/constraint/find-control-objects?query=${query}`,
  );
}

export async function fetchControlObjectsByNonErvkOrganization(
  request: FetchControlObjectsByNonErvkOrganizationParams,
): Promise<IErvkObjectsOfControl[]> {
  const {
    ervkKnoOrTerritoryAgencyId,
    ervkSupervisionId,
    ervkApplicationConditionId,
    isPlanned,
    organizationSubjectCode,
    inn,
    ogrn,
    ogrnip,
    kpp,
    snils,
    rafpNza,
    organizationName,
    identityDocumentNumber,
  } = request;

  return apiPost<IErvkObjectsOfControl[]>({
    url: `${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/control-objects/get-by-non-ervk-organization`,
    body: {
      ervkKnoOrTerritoryAgencyId,
      ervkSupervisionId,
      ervkApplicationConditionId,
      planned: isPlanned,
      organizationSubjectCode,
      inn,
      ogrn,
      ogrnip,
      kpp,
      snils,
      rafpNza,
      organizationName,
      identityDocumentNumber,
    },
  });
}

type FetchControlObjectsByNonErvkOrganizationParams = {
  ervkKnoOrTerritoryAgencyId: string;
  ervkSupervisionId: string;
  ervkApplicationConditionId: string;
  isPlanned: boolean;
  organizationSubjectCode: string;
  inn: string | null;
  ogrn: string | null;
  ogrnip: string | null;
  kpp: string | null;
  snils: string | null;
  rafpNza: string | null;
  organizationName: string | null;
  identityDocumentNumber: string | null;
};
